import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Typography,
  Avatar,
  Box,
  Select,
  MenuItem,
} from "@mui/material";
import endpoints from "../../../endpoint";
import Loader from "../../../comman/Loader";
import { useDispatch, useSelector } from "react-redux";
import { fetchpartnerbyId } from "../../../redux/slices/partnerSlice";

const PartnerProfile = () => {
  const partner = useSelector((state) => state?.partner);
  const data = partner?.fetchById;
  const loading = partner?.loading;
  const { partnerId } = useParams();
  const [formData, setFormData] = useState({});
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) {
      return;
    }
    dispatch(fetchpartnerbyId(partnerId));
  }, [partnerId]);

  if (!data && loading) {
    <Loader />;
  }

  const openEditDialog = () => {
    setFormData({ ...data }); // Pre-fill form with existing data
    setIsDialogOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      bankDetails: { ...formData.bankDetails, [name]: value },
    });
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.put(
        `${endpoints.serverBaseUrl}api/partner/update`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          withCredentials: true,
        }
      );

      if (response?.data?.success) {
        setIsDialogOpen(false);
        dispatch(fetchpartnerbyId(partnerId));
      }
    } catch (error) {
      console.error("Error updating partner:", error);
    }
  };

  return (
    <Box
      maxWidth="600px"
      mx="auto"
      p={4}
      boxShadow={3}
      borderRadius={2}
      bgcolor="white"
      mt={4}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Avatar sx={{ width: 80, height: 80, bgcolor: "gray" }}>
          {data?.userId?.picture ? (
            <img
              src={data?.userId?.picture}
              alt="Profile"
              style={{ width: "100%", height: "100%", borderRadius: "50%" }}
            />
          ) : (
            <Typography variant="h5">{data?.name?.charAt(0)}</Typography>
          )}
        </Avatar>
        <Box>
          <Typography variant="h6">{data?.name}</Typography>
          <Typography color="textSecondary">
            Partner ID: {data?.userId?.partnerId}
          </Typography>
          <Box
            px={2}
            py={0.5}
            borderRadius={16}
            bgcolor={data?.status === "approved" ? "green" : "yellow"}
            color={data?.status === "approved" ? "green" : "yellow"}
            display="inline-block"
            fontSize="0.2rem"
          >
            <Typography sx={{ color: "white" }}> {data?.status}</Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          mt: 3,
          p: 2,
          bgcolor: "white",
          borderRadius: "8px",
        }}
      >
        {/* First Row */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography variant="body1">
            <strong>Email:</strong> {data?.email}
          </Typography>
          <Typography variant="body1">
            <strong>Phone:</strong> {data?.mobile}
          </Typography>
        </Box>

        {/* Second Row */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography variant="body1">
            <strong>Experience:</strong> {data?.experience}
          </Typography>
          <Typography variant="body1">
            <strong>Description:</strong> {data?.description}
          </Typography>
        </Box>

        {/* Third Row */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography variant="body1">
            <strong>Total Earnings:</strong> ₹{Math.floor(data?.totalEarnings)}
          </Typography>
          <Typography variant="body1">
            <strong>Commission Rate:</strong> {data?.commissionRate}%
          </Typography>
        </Box>

        {/* Fourth Row */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography variant="body1">
            <strong>IFSC Code:</strong> {data?.bankDetails?.ifscCode}
          </Typography>
          <Typography variant="body1">
            <strong>Joined On:</strong>{" "}
            {new Date(data?.updatedAt).toLocaleDateString()}
          </Typography>
        </Box>
      </Box>
      ;
      <Box display="flex" justifyContent="flex-end" mt={3}>
        <Button variant="outlined" onClick={openEditDialog}>
          Edit
        </Button>
      </Box>
      <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Edit Partner Details</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="normal"
            label="Name"
            name="name"
            value={formData.name || ""}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Email"
            type="email"
            name="email"
            value={formData.email || ""}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Phone"
            name="mobile"
            value={formData.mobile || ""}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Experience"
            name="experience"
            value={formData.experience || ""}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Description"
            name="description"
            multiline
            rows={3}
            value={formData.description || ""}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Commission Rate (%)"
            name="commissionRate"
            type="number"
            value={formData.commissionRate || ""}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Total Earnings ($)"
            name="totalEarnings"
            type="number"
            value={formData.totalEarnings || ""}
            onChange={handleChange}
          />

          {/* Bank Details */}
          <Typography variant="h6" mt={3}>
            Bank Details
          </Typography>
          <TextField
            fullWidth
            margin="normal"
            label="Bank Name"
            name="bankName"
            value={formData.bankDetails?.bankName || ""}
            onChange={handleBankChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Account Number"
            name="accountNumber"
            value={formData.bankDetails?.accountNumber || ""}
            onChange={handleBankChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="IFSC Code"
            name="ifscCode"
            value={formData.bankDetails?.ifscCode || ""}
            onChange={handleBankChange}
          />

          <Select
            fullWidth
            name="status"
            value={formData.status || ""}
            onChange={handleChange}
            sx={{ mt: 2 }}
          >
            <MenuItem value="approved">Approved</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="rejected">Rejected</MenuItem>
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PartnerProfile;
